import { Component, Input } from '@angular/core';
import { Station } from '../../../../../../client/model/station';
import { Transport, TransportTaskStatus } from '../../../../../../common/model/transport.model';

@Component({
    selector: 'app-used-workingarea-item',
    templateUrl: './used-workingarea-item.component.html',
    styleUrls: ['./used-workingarea-item.component.scss'],
    standalone: false
})
export class UsedWorkingareaItemComponent {

  station: Station;

  transport: Transport;

  TransportTaskStatus = TransportTaskStatus;

  @Input("station") set setStation(station: Station) {
    this.station = station;
    this.transport = station.stationUsage.transports[0];
  }

  @Input() selected: boolean;

  endSuspension() { }

  startSuspension() { }
}
